import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {MatCheckbox, MatDialog} from '@angular/material';
import {Offer} from '../../../../../core/models/offer/offer.model';
import {OfferService} from '../../../../../core/services/impl/offer.service';
import {MetricsType} from '../../../../components/models/metrics/metrics-type.enum';
import {OfferMetricDataModel} from '../../../../components/models/metrics/offer-metric-data.model';
import {IframeCommunicationService} from '../../../../services/iframe-communication.service';
import {CustomMetricsName} from '../../../../components/models/metrics/custom-metrics-name.enum';
import {MetricsDataModel} from '../../../../components/models/metrics/metrics-data.model';
import {UrlParamsService} from '../../../../../core/services/impl/url-params.service';
import {ScrollHelper} from '../../../../services/scroll-helper';
import {LanguageService} from '../../../../services/language.service';
import {NavigateManagerService} from '../../../../../core/services/navigate-manager.service';
import {FiltersService} from '../../../../services/filters.service';
import {MetricsService} from '../../../../services/metrics.service';
import {isNext, orderCall} from '../../../../../core/utils/utils';
import {OfferBasicItemComponent} from '../../../../components/offer-basic-item/offer-basic-item.component';
import {Ga4EventsConfigService} from '../../../../../core/services/ga4-events-config.service';
import {Ga4OffersElementKey} from '../../../../../core/consts/ga4-offers-element-key.enum';
import {OfferResourceService} from '../../../../../core/services/impl/offer-resource.service';
import {OffersPresentationMode} from '../../../../../core/services/impl/offers-presentation.service';
import {
    OffersComparisonDialogComponent
} from '../../../../components/dialogs/offers-comparison-dialog/offers-comparison-dialog.component';
import {OffersPresentationComponent} from '../offers-presentation/offers-presentation.component';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})
export class OfferComponent extends OfferBasicItemComponent implements OnInit {

    @ViewChild('compareCheckbox') compareCheckbox: MatCheckbox;

    @Input() index: number;
    @Input() item: Offer;
    @Input() checkOfferAvailable: boolean;
    @Input() amountOfSelectedOffers: number;

    @Output() onSelectOffer: EventEmitter<void> = new EventEmitter();
    @Output() onCheckOffer: EventEmitter<void> = new EventEmitter();
    @Output() onUncheckOffer: EventEmitter<void> = new EventEmitter();
    @Output() onCompareOffers: EventEmitter<void> = new EventEmitter();

    @Input() checked: boolean;

    offerDetailsMetric: MetricsDataModel;
    isNext: boolean = isNext();

    constructor(resourceService: OfferResourceService,
                language: LanguageService,
                private dialog: MatDialog,
                private scrollHelper: ScrollHelper,
                private metricsService: MetricsService,
                private iframeService: IframeCommunicationService,
                private offerService: OfferService,
                private filtersService: FiltersService,
                private ga4EventsService: Ga4EventsConfigService,
                public urlParamsService: UrlParamsService,
                private navigateManager: NavigateManagerService) {
        super(resourceService, language);
    }

    get offersComparisonButtonText(): string {
      return this.checked ? 'OFFER_SECTION.BOX.compareSelected' : 'OFFER_SECTION.BOX.addToComparison';
    }

    get metricValue(): OfferMetricDataModel {
        return {
            offerId: this.item.id,
            calculationId: this.offerService.calculationId,
            processId: this.offerService.processId
        };
    }

    ngOnInit() {
        this.createBoxes(this.item);
        this.setAmount(this.item);
        this.setLogo(this.item);
        this.filtersService.filtersChangeEvent.subscribe(() => {
            if (this.checked) {
                this.compareCheckbox.checked = false;
                this.onChangeCheckbox();
            }
        });
    }

    openOffersPresentation() {
        this.openMetric();
        this.ga4EventsService.sendOffersElementEvent(Ga4OffersElementKey.OFFER_DETAILS);
        const dialogComponent: any = this.isNext ? OffersComparisonDialogComponent : OffersPresentationComponent;
        this.dialog.open(dialogComponent,
            dialogComponent.getConfigBuilder().buildConfiguration({
                offers: [this.item],
                mode: OffersPresentationMode.OFFER_DETAILS,
                selectOfferEvent: null
            })).afterClosed().subscribe(offer => {
            this.closeMetric();
            if (offer) {
                this.onSelectOffer.emit();
            }
        });
    }

    onChangeCheckbox() {
        if (this.checked) {
            this.onUncheckOffer.emit();
        } else {
            this.onCheckOffer.emit();
            this.ga4EventsService.sendOffersElementEvent(Ga4OffersElementKey.COMPARE_OFFERS_ADD);
        }
    }

    compareOffers(event: PointerEvent) {
      if (this.checked) {
          this.onCompareOffers.emit();
          event.preventDefault();
          this.ga4EventsService.sendOffersElementEvent(Ga4OffersElementKey.COMPARE_OFFERS_PROCEED);
      }
    }

    buyNow() {
        this.ga4EventsService.sendOffersElementEvent(Ga4OffersElementKey.BUY_ONLINE_LIST);
        const missingPersonalDataParams = this.offerService.getMissingPersonalDataParams(this.item.id);
        if (missingPersonalDataParams.length || this.offerService.isEmailAddressMissingAndRequired()) { // read only - open dialog
            this.navigateManager.openMissingPersonalDataDialog(missingPersonalDataParams);
        } else { // no missing params - navigate to payment step
            this.onSelectOffer.emit();
            this.iframeService.onStepChange();
        }
    }

    orderCall(): void {
        this.ga4EventsService.sendOffersElementEvent(Ga4OffersElementKey.ORDER_CALL);
        orderCall();
    }

    private openMetric(): void {
        this.offerDetailsMetric = new MetricsDataModel(CustomMetricsName.OFFER_DETAILS, MetricsType.COMPONENT);
        this.offerDetailsMetric.open();
        this.offerDetailsMetric.value = JSON.stringify(this.metricValue);
    }

    private closeMetric(): void {
        this.offerDetailsMetric.close();
        this.metricsService.send(this.offerDetailsMetric);
    }

}
